<template>
	<div>
		<md-button class="md-raised md-round md-accent interact" @click="$emit('interact', action)">
			{{ action }}
		</md-button>
	</div>
</template>
<!-- Script-->
<script>
export default {
  name: "interaction-button",
  props: ["interaction"],
  data() {
    return {
      action: this.interaction
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/BaseInteractionButton.vue